module.exports = __webpack_public_path__ + "media/images/proof_links/colored/goodreads-b6cb87183fb97d37361b08fc87e216b5.svg";